<template>
  <div v-if="localCompany">
    <div
      class="flex justify-center items-start min-h-screen p-4 sm:p-6"
      :style="{ backgroundColor: localCompany?.colorpage || '#D3D3D3' }"
    >
      <div
        class="bg-white shadow-lg rounded-lg p-4 w-full max-w-sm sm:max-w-md md:max-w-lg"
      >
        <!-- Logo -->
        <div class="logo-container">
          <img
            v-if="localCompany.logofilename"
            :src="`${apiBaseUrl}/static/logos/${localCompany.logofilename}`"
            alt="Logo da Empresa"
            class="w-40 h-auto mx-auto"
          />
        </div>

        <!-- Nome da empresa -->
        <h1
          v-if="localCompany && localCompany.hide_name === false"
          class="text-gray-700 font-semibold text-xl sm:text-2xl md:text-3xl mb-8 text-center"
        >
          {{ localCompany.name }}
        </h1>

        <!-- Título do Feedback -->
        <h1
          class="text-gray-700 font-semibold text-lg mb-4 text-center sm:text-left mt-8"
        >
          O que motivou esta sua nota?
        </h1>

        <!-- Campo de Feedback -->
        <textarea
          v-model="feedback"
          placeholder="Descreva aqui..."
          class="w-full p-4 border border-gray-300 rounded-lg mb-6 bg-gray-50 focus:bg-white shadow-inner focus:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all duration-200"
          rows="4"
        ></textarea>

        <!-- Seção de Contato -->
        <div class="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-100">
          <p class="text-gray-600 text-sm mb-4">
            Quer receber um retorno sobre sua avaliação? Deixe seus dados
            abaixo:
          </p>

          <!-- Campo Nome -->
          <div class="mb-4">
            <input
              v-model="contactName"
              type="text"
              placeholder="Seu nome (opcional)"
              class="w-full p-3 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all duration-200"
            />
          </div>

          <!-- Campo WhatsApp -->
          <div class="mb-2">
            <phone-input
              ref="phoneInput"
              v-model="contactPhone"
              input-class="w-full p-3 border border-gray-300 rounded-lg bg-white
               focus:outline-none focus:ring-2 focus:ring-blue-100 
               focus:border-blue-300 transition-all duration-200"
            />
          </div>

          <!-- Texto explicativo -->
          <p class="text-gray-500 text-xs mt-2">
            Seus dados serão usados apenas para:
            <br />• Esclarecer eventuais dúvidas <br />• Informar sobre ações
            tomadas <br />• Melhorar nosso atendimento
          </p>
        </div>

        <!-- Botão de Enviar -->
        <div class="flex justify-center mt-6">
          <button
            @click="submitFeedback"
            class="text-white font-semibold rounded-lg text-base px-4 py-2 hover:opacity-90 sm:text-lg sm:px-6"
            :style="{ backgroundColor: localCompany.colorbutton || '#0A66C2' }"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? "Enviando..." : "Enviar" }}
          </button>
        </div>

        <!-- Rodapé -->
        <div class="text-xs text-gray-500 text-right mt-6">
          <p v-if="localCompany.footer_credit">Feito com ❤️ por Avalioo</p>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <p>Carregando...</p>
  </div>
</template>

<script>
//import PhoneInput from './PhoneInput.vue';
import PhoneInput from "@/modules/shared/components/ui/PhoneInput.vue";
import npsService from "@/services/nps.service";
import { useCompanyStore } from "@/stores/company";
import { notificationService } from "@/services/notifications/NotificationService";
import { formatDateTime } from "@/utils/dateFormatter";

export default {
  components: {
    PhoneInput, // Registre o componente
  },
  props: {
    nps: { type: Number, required: true },
  },
  data() {
    return {
      feedbackType: "elogio",
      feedback: "",
      contactName: "", // Novo campo para nome
      contactPhone: "", // Novo campo para telefone/WhatsApp
      isSubmitting: false,
      apiBaseUrl: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    localCompany() {
      const companyStore = useCompanyStore();
      return companyStore.tempCompany;
    },
  },
  methods: {
    async submitFeedback() {
      if (this.isSubmitting) return;

      console.log("InternalForm->submitFeedback->localcompany", this.localCompany);
      //Pergunta: se esse formulário é publico, nao se precisa assinar, como que a variavel this.localCompany (from store) é armazenada?

      // Validação do telefone
      const phoneInput = this.$refs.phoneInput;
      if (this.contactPhone && !phoneInput.isValid) {
        alert("Por favor, insira um número de telefone válido.");
        return;
      }

      console.log("Valor do telefone antes do envio:", this.contactPhone);

      try {
        this.isSubmitting = true;
        const reviewId = this.$route.query.review_id;
        const score_nps = parseInt(this.$route.query.nps);

        if (!reviewId) {
          throw new Error("ID do review não encontrado");
        }

        if (isNaN(score_nps)) {
          throw new Error("NPS inválido");
        }

        console.log(
          "depois de enviar internal form. localcompany",
          this.localCompany
        );
        const payload = {
          review_id: reviewId,
          id_company: this.localCompany.company_id,
          nps: score_nps,
          type: 0,
          review: this.feedback,
          contactname: this.contactName, // Novos campos adicionados ao payload
          contactphone: this.contactPhone,
          contactemail: "",
          id_branch: this.localCompany.id_branch
        };

        console.log("Payload antes do envio:", payload);

        if (this.feedback || this.contactName || this.contactPhone) {
          // console.log ("payload 4 ante do updateReview:::", payload);
          await npsService.updateReview(reviewId, payload);

          if (score_nps <= this.localCompany.notification_score_threshold) {
            console.log("entrando para enviar msg");
            if (this.localCompany.email_notifications_enabled) {
              const contactWhatsapp = this.contactPhone.replace(/\D/g, "");
              // Verifica se tem pelo menos 10 dígitos (DDD + número)
              // Se não tiver, deixa link em branco
              const linkDiretoWhatsapp =
                contactWhatsapp.length >= 10
                  ? `https://wa.me/55${contactWhatsapp}`
                  : "";

              await notificationService.sendEmailTemplate(
                "alertDetrator",
                {
                  score: score_nps,
                  review: this.feedback,
                  datahora: formatDateTime(),
                  companyName: this.localCompany.name,
                  branchName: this.localCompany.branch_name,
                  contactName: this.contactName,
                  contactPhone: this.contactPhone,
                  contactWhatsapp: contactWhatsapp,
                  linkDiretoWhatsapp: linkDiretoWhatsapp,
                },
                this.localCompany.notification_email
              );
            }
            console.log("antes de enviar msg de whatsapp whatsapp_notifications_enabled", this.localCompany.whatsapp_notifications_enabled);
            if (this.localCompany.whatsapp_notifications_enabled) {
              console.log("dentro da funcao de enviar msg de whatsapp");
              const contactWhatsapp = this.contactPhone.replace(/\D/g, "");
              // Verifica se tem pelo menos 10 dígitos (DDD + número)
              // Se não tiver, deixa link em branco
              const linkDiretoWhatsapp =
                contactWhatsapp.length >= 10
                  ? `https://wa.me/55${contactWhatsapp}`
                  : "";

              await notificationService.sendWhatsappTemplate(
                "alertDetrator",
                {
                  score: score_nps,
                  review: this.feedback,
                  datahora: formatDateTime(),
                  companyName: this.localCompany.name,
                  branchName: this.localCompany.branch_name,
                  contactName: this.contactName,
                  contactPhone: this.contactPhone,
                  contactWhatsapp: contactWhatsapp,
                  linkDiretoWhatsapp: linkDiretoWhatsapp,
                },
                this.localCompany.notification_phone
              );
            }

            if (this.localCompany.sms_notifications_enabled) {
              console.log("sms");
            }
          }
        }

        this.$router.push({
          name: "ThankYouPage",
        });
      } catch (error) {
        console.error("Erro ao enviar feedback:", error);
        if (error.response) {
          console.error("Detalhes do erro:", error.response.data);
        }
        alert("Erro ao enviar seu feedback. Tente novamente.");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
